import { SignIn } from "@clerk/clerk-react";
import { TopNav } from "../components/layout/top-nav";

export function AuthPage() {
  return (
    <div className="min-h-screen bg-white">
      <TopNav user={null} />
      
      <main className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md mx-auto">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-3">
              欢迎使用 Persona
            </h1>
            <p className="text-gray-500">
              登录或注册开始你的 AI 助手之旅
            </p>
          </div>

          {/* Clerk SignIn Component */}
          <div className="flex justify-center">
            <SignIn 
              routing="hash"
              signUpUrl="#/sign-up"
              appearance={{
                elements: {
                  rootBox: "w-full max-w-md",
                  card: "shadow-none border border-gray-200",
                  headerTitle: "text-xl font-semibold text-gray-900",
                  headerSubtitle: "text-gray-500",
                  socialButtonsBlockButton: "w-full border border-gray-200 hover:bg-gray-50",
                  socialButtonsBlockButtonText: "text-gray-700 font-medium",
                  dividerLine: "bg-gray-200",
                  dividerText: "text-gray-400 text-sm",
                  formFieldLabel: "text-sm font-medium text-gray-700",
                  formFieldInput: "w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                  formButtonPrimary: "w-full bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-medium py-3",
                  footerActionLink: "text-blue-500 hover:text-blue-600",
                },
              }}
            />
          </div>
        </div>
      </main>
    </div>
  );
}
